import React, { SyntheticEvent } from 'react';

import { getClass } from '../../../ship/utils/component-helpers';

const Checkbox = (props: any) => {
  const {
    checked = false,
    color = 'default',
    onSelect = () => {},
    disabled = false,
    size = '',
    id = null,
    stopPropagation = false,
    showDeselect = false,
  }: {
    checked: boolean;
    color?: string;
    onSelect: (e: SyntheticEvent) => void;
    disabled?: boolean;
    size?: string;
    id?: any;
    stopPropagation?: boolean;
    showDeselect?: boolean;
  } = props;

  const handleChange = (e: any) => {
    onSelect(e.target.checked);
  };

  const bgColor: any = {
    red: 'checked:bg-quasar-400',
    green: 'checked:bg-nebula-300',
    blue: 'checked:bg-azure-400',
    purple: 'checked:bg-aurora-300',
    yellow: 'checked:bg-tatooine-300',
    default: 'checked:bg-interaction-primary',
  };

  const borderColor: any = {
    red: 'border-quasar-400',
    blue: 'border-azure-400 ',
    purple: 'border-aurora-300',
    green: 'border-nebula-300',
    yelow: 'border-tatooine-300',
    default: 'border-deep-space-500/30',
  };

  const className = getClass(
    'custom-checkbox cursor-pointer relative border appearance-none rounded focus:outline-none flex-none border-2 checked:border checked:border-interaction-primary',
    {
      [bgColor[color] || 'checked:bg-primary-blue-1000']: !disabled && !!color,
      [borderColor[color] || 'border-deep-space-500']: !disabled && !!color,
      'border-neutral-gray-300': !!disabled,
      'cursor-not-allowed': disabled,
      'w-4 h-4 checked:after:w-[4px] checked:after:h-[9px] checked:after:top-[2px] checked:after:left-[5px]':
        !size,
      [size]: size,
      'checked:after:bg-white checked:after:rotate-180 checked:after:border-0 checked:after:h-[2px] checked:after:w-[10px] checked:after:top-[6px] checked:after:left-[2px]':
        showDeselect,
    },
  );

  return (
    <input
      type="checkbox"
      checked={checked}
      style={{}}
      className={className}
      onChange={handleChange}
      onClick={(e) => stopPropagation && e.stopPropagation()}
      disabled={disabled}
      id={id}
    />
  );
};

export default Checkbox;
